// extracted by mini-css-extract-plugin
export var alertIcon = "_re-0";